// extracted by mini-css-extract-plugin
export default {"shipping_address_flex_contact":"ShippingAddressCard_shipping_address_flex_contact__lUdSI","shipping_address_li_inner":"ShippingAddressCard_shipping_address_li_inner__ipJ82"};